import { z } from 'zod';
/**
 * Email the app sends itself (owner, 2026-09-21, story 43): the sign-in
 * link, the password-reset link and the invite all leave from the company's
 * own Gmail mailbox, through the server, instead of from Firebase. The
 * server asks the Admin SDK for the one-time code, puts it on a link under
 * the app's own domain and mails it; Firebase's own email never goes out.
 *
 * The two public endpoints answer the same `{ ok: true }` whether or not the
 * address has an account — the sign-in screen must not become an account
 * probe — and are rate limited per address and per caller.
 */
export const emailAddressRequestSchema = z.object({
    email: z.string().trim().toLowerCase().email().max(254),
});
/** POST /api/public/sign-in-link, POST /api/public/password-reset, POST /api/users/:uid/invite. */
export const mailSentResponseSchema = z.object({ ok: z.literal(true) });
/** Requests for a link from one address, sliding hour. */
export const MAX_MAIL_REQUESTS_PER_IP_HOUR = 30;
/** Links mailed to one recipient, sliding hour. */
export const MAX_MAIL_REQUESTS_PER_EMAIL_HOUR = 10;
/** What one email is for; the template and the outbox both carry it. */
export const mailKindSchema = z.enum(['sign_in', 'password_reset', 'invite']);
/**
 * GET /api/dev/mail?email= — DEVELOPMENT ONLY. Under the emulator every
 * email is also parked in the `mailOutbox` collection; this lists what was
 * parked for one address so the sign-in screen's dev button and the e2e
 * suite can follow the link. The route does not exist outside the emulator.
 */
export const devMailQuerySchema = emailAddressRequestSchema;
export const devMailMessageSchema = z.object({
    id: z.string(),
    to: z.string(),
    kind: mailKindSchema,
    subject: z.string(),
    link: z.string(),
    sentAt: z.string().nullable(),
});
export const devMailResponseSchema = z.object({ messages: z.array(devMailMessageSchema) });
//# sourceMappingURL=auth.js.map